export const DEFAULT_MINIMUM_VELOCITY_THRESHOLD = 0.1;
export const DEFAULT_MINIMUM_DISTANCE_THRESHOLD = 0.24;
export const KEYBOARD_TRANSITION_DURATION = 160;
export const KEYBOARD_EXTRA_MARGIN = 75;
export const DEFAULT_FRICTION = 0.998;
export const DELTA_THRESHOLD = 0.5;
export const TIME_CONSTANT = 325;
